import {useEffect, useState} from 'react';

import {isMountedInShell} from '../../shellRemote';
import {TOP_NAV_HEIGHT} from '../constants';

/**
 * Height of the app navbar that a fixed-position drawer has to clear. Under the
 * Forge shell the shell header replaces the navbar, so there is nothing to
 * clear. CSS reads the same value from `--wb-drawer-top-padding`
 * (src/css/layout-tokens.css), also exposed as the `drawer-top` Tailwind
 * spacing key. Use this for a static offset; use `useNavbarBottom` when the
 * offset should follow the navbar as it scrolls out of view.
 */
export function navbarHeight(): number {
  return isMountedInShell() ? 0 : TOP_NAV_HEIGHT;
}

/**
 * Where the bottom edge of the navbar currently sits in the viewport. The
 * navbar scrolls with the page, so this shrinks to 0 as it leaves the fold.
 */
export function useNavbarBottom() {
  const [navbarBottom, setNavbarBottom] = useState(
    Math.max(0, navbarHeight() - window.scrollY)
  );

  useEffect(() => {
    const update = () => {
      setNavbarBottom(Math.max(0, navbarHeight() - window.scrollY));
    };

    document.addEventListener('scroll', update, {capture: true, passive: true});
    window.addEventListener('resize', update, {passive: true});
    return () => {
      document.removeEventListener('scroll', update, {capture: true});
      window.removeEventListener('resize', update);
    };
  }, []);

  return navbarBottom;
}
